module.exports = __webpack_public_path__ + "static/media/Hidro-SP.81a17b4b.jpg";